import { render } from "./TreeChart.vue?vue&type=template&id=5649378e&scoped=true"
import script from "./TreeChart.vue?vue&type=script&lang=js"
export * from "./TreeChart.vue?vue&type=script&lang=js"

import "./TreeChart.vue?vue&type=style&index=0&id=5649378e&scoped=true&lang=css"

import exportComponent from "D:\\Workspace\\tower1229\\Vue-Tree-Chart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5649378e"]])

export default __exports__